import "core-js/modules/es6.array.some";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import nanoidGenerate from "nanoid/generate";
import nanoidDictionary from "nanoid-dictionary/lowercase";
import { get, startsWith, trim, trimStart, trimEnd, isNil, fill, isPlainObject } from "lodash-es";
import numeral from "numeral";
import { tokenize } from "./parser";
import { NODE_NAME_MAX_LENGTH } from "./common";
export var generateId = function generateId() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return nanoidGenerate(nanoidDictionary, length);
};
export var getNewNodeName = function getNewNodeName() {
  var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "name_";
  var count = 0;
  var prefixLength = prefix.length;
  nodes.forEach(function (_ref) {
    var name = _ref.name;

    if (name.length > prefixLength && prefix === name.substring(0, prefixLength).toLowerCase()) {
      var suffix = name.substring(prefixLength, name.length);
      !isNaN(suffix) && +suffix >= count && (count = +suffix);
    }
  });
  return prefix + (count + 1);
};
export var getNewFormulaName = function getNewFormulaName(nodes) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "formula";
  return getNewNodeName(nodes, prefix);
};
export var getNewTableName = function getNewTableName(nodes) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "table";
  return getNewNodeName(nodes, prefix);
}; // ToDo: optimise; function below is almost the same as getNewNodeName

export var getNewColumnName = function getNewColumnName(_ref2) {
  var columns = _ref2.columns;
  var count = 0;
  var prefix = "Column";
  var prefixLength = prefix.length;
  columns.forEach(function (_ref3) {
    var name = _ref3.name;

    if (name.length > prefixLength && prefix.toLowerCase() === name.substring(0, prefixLength).toLowerCase()) {
      var suffix = name.substring(prefixLength, name.length);
      !isNaN(suffix) && +suffix >= count && (count = +suffix);
    }
  });
  return prefix + (count + 1);
};
export var stripBrackets = function stripBrackets(text) {
  var startBracket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "[";
  var endBracket = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "]";
  return trimEnd(trimStart(text, startBracket), endBracket);
};
export var wrapWithBrackets = function wrapWithBrackets(text) {
  var startBracket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "[";
  var endBracket = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "]";
  return "" + startBracket + text + endBracket;
};
export var isFormula = function isFormula(text) {
  return startsWith(text, "=");
};
export var formatValue = function formatValue(value) {
  return !value || value === "" || isNaN(value) ? value : parseFloat(value);
};
export var getFormattedValue = function getFormattedValue(value, formatter) {
  if (isNil(value) || value === "") {
    return "";
  }

  if (value instanceof Date) {
    // ToDo: handle dates better
    return value.toDateString();
  }

  if (isNil(formatter)) {
    return value;
  }

  return numeral(value).format(formatter);
};
export var standardizeInput = function standardizeInput(input) {
  if (!input) {
    return input;
  }

  if (isNaN(input)) {
    return trim(input);
  }

  return parseFloat(input);
};
export var stripFormulaSign = function stripFormulaSign() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return trimStart(text, "=").trim();
};
export var prependWithFormulaSign = function prependWithFormulaSign() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var spaceAfter = arguments[1];
  return "=" + (spaceAfter || "") + text;
};
export var getFormulaHints = function getFormulaHints() {
  var formulas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments[1];
  return formulas.filter(function (f) {
    return f.id !== id;
  }).map(function (_ref4) {
    var name = _ref4.name,
        formatted = _ref4.formatted;
    return {
      name: name,
      description: "value: " + formatted
    };
  });
};
export var getTablesHints = function getTablesHints() {
  var tables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return tables.map(function (_ref5) {
    var name = _ref5.name;
    return {
      name: name,
      description: "Table name for " + name
    };
  });
};
export var pause = function pause() {
  return new Promise(function (resolve) {
    setTimeout(resolve);
  });
};
export var monacoTokenizer = function monacoTokenizer(text, monaco, languageId) {
  var _monaco$editor$tokeni = monaco.editor.tokenize(text, languageId),
      tokens = _monaco$editor$tokeni[0];

  return tokens.map(function (token, i) {
    return _extends({}, token, {
      text: text.substring(token.offset, tokens[i + 1] ? tokens[i + 1].offset : undefined)
    });
  });
};
export var validateNodeName = function validateNodeName(name) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NODE_NAME_MAX_LENGTH;

  if (!name || typeof name !== "string" || name === "" || name.length > maxLength) {
    return false;
  }

  return /^[a-zA-Z][a-zA-Z_\d]+$/.test(name);
};
export var hasCircularDependency = function hasCircularDependency(name, expression) {
  return tokenize(expression).some(function (token) {
    return get(token, "name") === name;
  });
}; // ToDo: test if works for more complicated formulas like table1[[foo]:[bar]

export var hasCircularDependencyTableColumn = function hasCircularDependencyTableColumn(name, expression, tableName) {
  return tokenize(expression).filter(function (t) {
    return isPlainObject(t) && t.type === "table" && t.name === tableName;
  }).some(function (_ref6) {
    var _ref6$intraTableRefer = _ref6.intraTableReference,
        intraTableReference = _ref6$intraTableRefer === undefined ? [] : _ref6$intraTableRefer;
    return intraTableReference.some(function (t2) {
      return isPlainObject(t2) && t2.type === "columnRange" && t2.columns.some(function (c) {
        return c.name === name;
      });
    });
  });
};
export var mapColumnsToCells = function mapColumnsToCells() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return columns.map(function (_ref7) {
    var id = _ref7.id;
    return _extends({
      column: id
    }, value);
  });
};
export var createAndFillGrid = function createAndFillGrid() {
  var rowCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  var columns = arguments[1];
  var value = arguments[2];
  return fill(Array(rowCount), {
    cells: mapColumnsToCells(columns, value)
  });
};
export var reorderArrayElements = function reorderArrayElements(_array, oldIndex, newIndex) {
  var length = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var array = _array.slice(); // in order to not mutate original array


  var slice = array.splice(oldIndex, length);
  array.splice.apply(array, [newIndex, 0].concat(slice));
  return array;
};